export default __webpack_public_path__ + "ba5b421f03bd5f615e6a775872d252ce.png";